var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFundraiser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fundraiser_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v900H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fundraiser_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0A3.5 3.5 0 017 3.5a3.48 3.48 0 01-1.355 2.746A14.48 14.48 0 003 6c-.619 0-1.22.043-1.805.115A3.476 3.476 0 010 3.5 3.5 3.5 0 013.5 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fundraiser_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0h24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fundraiser_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.021 1.2c-.18-.9.846-1.548 1.581-.997L8.161 2.31C9.054 2.111 10.007 2 11 2c4.971 0 9 2.687 9 6 0 1.461-.784 2.8-2.086 3.84l-.753 3.356a1.001 1.001 0 01-.981.804h-1.503c-.408 0-.777-.249-.929-.629l-.618-1.547c-.685.111-1.395.176-2.13.176-.735 0-1.446-.065-2.129-.176l-.62 1.547a.998.998 0 01-.928.63H5.82c-.477 0-.887-.338-.981-.805l-.521-2.605-3.833-2.3A1.002 1.002 0 010 9.434V8a1 1 0 011-1h1.135c.32-1.267 1.226-2.4 2.539-3.266z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fundraiser_svg__a)",
    transform: "translate(-26 -226)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fundraiser_svg__b)",
    transform: "translate(34 226)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fundraiser_svg__c)",
    transform: "translate(-10 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D2121",
    opacity: "50%",
    d: "M10 1h7v6.246h-7V1z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fundraiser_svg__d)",
    transform: "translate(26 231)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fundraiser_svg__c)",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M2 6h20v16H2V6z"
  }))))));
}

export default SvgFundraiser;